export const activeTable = id => ({
    type: id
});

const initialState = 'SQUARES';

export default (state = initialState, action ={}) => {
    switch(action.type) {
        case 'mata-squares':
            return 'SQUARES';
        case 'mata-circles':
            return 'CIRCLES';
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/activeTable.js